export type HexLayer = 'meanPrice' | 'priceChange';

export function MapLayerToggle({
  layer,
  onChange,
}: {
  layer: HexLayer;
  onChange: (layer: HexLayer) => void;
}) {
  return (
    <div className="map-layer-toggle" role="group" aria-label="Map layer">
      <button
        type="button"
        aria-pressed={layer === 'meanPrice'}
        onClick={() => onChange('meanPrice')}
      >
        Mean price
      </button>
      <button
        type="button"
        aria-pressed={layer === 'priceChange'}
        onClick={() => onChange('priceChange')}
      >
        Price change
      </button>
    </div>
  );
}
